@if (showWarningBanner) {
	<div class="sidenav__mine-logo sidenav__live-account-banner"
		[class.sidenav__mine-logo--shrink]="shrink">
		<span class="sidenav__live-account-text">{{
			(shrink ? "common.liveAccountBannerShrink" : "common.liveAccountBanner") | content
		}}</span>
	</div>
} @else {
	<div class="sidenav__header"
		[class.sidenav__header--shrink]="shrink">
		<a
			class="sidenav__mine-logo sidenav__mine-logo--clickable"
			[class.sidenav__mine-logo--shrink]="shrink"
			routerLink="/{{ routesManager.homePage }}"
			(click)="logAnalyticsEvent(analyticEventsConsts.SIDEBAR_progrees_bar)"
		>
			<img class="sidenav__mine-logo-image" src="{{ assetsUrl }}/Portal/mine-os-white-logo.svg" />
			<div class="sidenav__mine-logo-image-hidden"></div>
		</a>
		<app-notifications-bell class="sidenav__notifications-bell"
			[class.sidenav__notifications-bell--shrink]="shrink">
		</app-notifications-bell>
	</div>
}

<div class="sidenav__items-wrapper">
	<section class="sidenav__section" [class.sidenav__section--shrink]="shrink">
		<app-sidenav-content [shrink]="shrink"></app-sidenav-content>
	</section>
</div>

<section class="sidenav__section sidenav__section--sticky">
	<a
		[attr.data-label]="'menu.chat' | content"
		href="javascript:void(0)"
		(click)="openIntercom()"
		class="sidenav__button sidenav__mt-auto"
		[tp]="'menu.chat' | content"
		[tpIsEnabled]="shrink"
		[tpPlacement]="tpProps.placement"
	>
		<svg [attr.data-label]="'menu.help' | content" class="sidenav__svg">
			<use xlink:href="../../../assets/img/sprite.svg#icon-message-full"></use>
		</svg>
		<span class="sidenav__link-text hide"> {{ "menu.chatWithUs" | content }} </span>
	</a>

	<ng-container *minePermissions="whatsNewPermittedrRoles">
		<div
			class="beamerTrigger sidenav__button"
			[attr.data-label]="'menu.whatsNew' | content"
		>
			<svg [attr.data-label]="'menu.whatsNew' | content" class="sidenav__svg">
				<use xlink:href="../../../assets/img/sprite.svg#icon-bell"></use>
			</svg>
			<span class="sidenav__link-text hide"> {{ "menu.whatsNew" | content }} </span>
		</div>
	</ng-container>

	<a
		[attr.data-label]="'menu.help' | content"
		href="javascript:void(0)"
		(click)="onHelpClick()"
		class="sidenav__button sidenav__mt-auto"
		[tp]="'menu.help' | content"
		[tpIsEnabled]="shrink"
		[tpPlacement]="tpProps.placement"
	>
		<svg [attr.data-label]="'menu.help' | content" class="sidenav__svg">
			<use xlink:href="../../../assets/img/sprite.svg#icon-info-tooltip"></use>
		</svg>
		<span class="sidenav__link-text hide"> {{ "menu.help" | content }} </span>
	</a>

</section>

<div class="sidenav__app-menu-container">
	<app-menu class="sidenav__app-menu"></app-menu>
	<div class="sidenav__shrink-btn"
		[class.sidenav__shrink-btn--open]="!alwaysOpen"
		[class.sidenav__shrink-btn--shrink]="shrink"
		(click)="toggle()">
		<svg class="sidenav__shrink-btn-svg">
			<use xlink:href="../../../assets/img/sprite.svg#icon-decrease"></use>
		</svg>
		<svg class="sidenav__shrink-btn-svg sidenav__shrink-btn-svg--close">
			<use xlink:href="../../../assets/img/sprite.svg#icon-increase"></use>
		</svg>
	</div>
	<div class="sidenav__app-menu-hidden"></div>
</div>
